module.exports = __webpack_public_path__ + "408485bd5b52d7ee12730cf1ff51c7a4.pdf";